import LoaderSpin from 'snippets/loader-spin/loader-spin'
import Price from 'snippets/price/price'
import Icon from 'snippets/icon/icon'

function ButtonATCCustom({
  onHandle,
  price,
  originalPrice,
  loading,
  disabled = false,
  type = 'button',
  text = 'Add',
  buttonClass = 'button-primary button-large',
  buttonTextClass,
  isMobileLayout = false
}) {
  let classCustom = `relative w-full border-t border-neutral-900 mt-auto ${buttonClass}`

  if (!isMobileLayout) {
    classCustom += `transition-opacity duration-300 xl:opacity-0 ${!disabled ? 'group-hover:xl:opacity-100' : 'xl-max:opacity-30 group-hover:xl:opacity-30'}`
  } else {
    classCustom += `${disabled ? 'opacity-30' : ''}`
  }

  return (
    <button
      type={type === 'button' ? 'button' : 'submit'}
      className={classCustom}
      disabled={disabled}
      onClick={() => onHandle()}
    >
      <Price className="flex flex-wrap items-center px-4 pt-0.5 h-full text-xs text-neutral-900" price={price} originalPrice={originalPrice} />
      <div className={`min-h-[43px] border-l border-neutral-900 px-3.5 pb-2.5 pt-[13px] ${!isMobileLayout ? 'lg:min-w-24 lg:px-5' : ''}`}>
        {loading ? (
          <LoaderSpin size={4} className="mx-auto" />
        ) : (
          <span className="flex gap-2 text-xs uppercase">
            <Icon
              name="icon-plus-medium"
              viewBox="0 0 16 16"
              className={`size-4 ${disabled ? 'text-neutral-700' : 'text-neutral-900'}`}
            />
            <span className={`${buttonTextClass} ${isMobileLayout ? 'hidden' : ''}`}>{text}</span>
          </span>
        )}
      </div>
    </button>
  )
}

export default ButtonATCCustom
